<template>
  <div :class="['dialog', { visible: visible }]">
    <div class="title">{{ title }}</div>
    <div class="closeBtn" @click="close"></div>
    <div class="content">
      <a-table
        bordered
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :scroll="{ y: 1050 }"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
import { getAreaSaleTotalDetail } from '@/api/dashboard'
import to from 'await-to'
const defaultCol = [
  {
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: '140px',
  },
  {
    title: '镇办',
    dataIndex: 'districtName',
    key: 'districtName',
    align: 'center',
    width: '200px',
  },
  {
    title: '村、社区',
    dataIndex: 'village',
    key: 'village',
    align: 'center',
    width: '280px',
  },
]
export default {
  name: 'TableDetail',
  data() {
    return {
      title: '',
      visible: false,
      columns: [],
      list: [],
      // pagination: {
      //   current: 1,
      //   pageSize: 11,
      //   total: 0,
      // },
    }
  },
  methods: {
    show(col, item) {
      this.title = col.name
      this.visible = true
      this.columns = [
        ...defaultCol,
        {
          title: col.name,
          dataIndex: col.key,
          key: col.key,
          align: 'center',
        },
      ]
      // this.pagination = {
      //   current: 1,
      //   pageSize: 11,
      //   total: 0,
      // }
      this.initData(item.id)
    },
    close() {
      this.visible = false
      this.title = ''
      this.columns = []
      this.list = []
    },
    async initData(id) {
      const [res, err] = await to(getAreaSaleTotalDetail({ id }))
      if (err) return
      this.list = res.data
      // this.pagination.total = res.data.total
    },
    // onChange({ current }) {
    //   this.pagination.current = current
    //   this.initData()
    // },
  },
}
</script>
<style lang="scss" scoped>
.dialog {
  z-index: 99999999;
  width: 1399px !important;
  height: 1570px !important;
  background: url('~@/img/datav/dialog_bg_s.png');
  background-size: 100% 100%;
  position: fixed;
  left: 1360px;
  top: 423px;
  display: none;
  .title {
    font-size: 57px;
    text-align: center;
    line-height: 107px;
    margin-bottom: 87px;
  }
  .closeBtn {
    cursor: pointer;
    width: 58px;
    height: 58px;
    position: absolute;
    right: 40px;
    top: 34px;
    background: url('~@/img/datav/dialog_close_btn.png');
    background-size: 100% 100%;
  }
  .content {
    padding: 0 62px;
    ::v-deep .ant-table {
      table {
        border-left: 1px solid #f5f5f5;
        border-top: 1px solid #f5f5f5;
      }
      .ant-table-thead {
        box-sizing: border-box;
        border: 0;
        border-color: #f5f5f5;
        font-size: 36px;
        line-height: 36px;
        background: #fff linear-gradient(180deg, #145fa3, #174da8);
        > tr > th {
          background: transparent;
          color: #fff;
          border-color: #f5f5f5;
          padding-top: 42px;
          padding-bottom: 42px;
        }
      }
      .ant-table-header {
        background: transparent;
      }
      .ant-table-body {
        background: transparent;
        /* 设置滚动条的样式 */
        &::-webkit-scrollbar {
          border-radius: 15px;
          width: 17px;
          background-color: transparent;
        }
        /* 滚动槽 */
        &::-webkit-scrollbar-track {
          border-radius: 15px;
          background-color: transparent;
        }
        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          border-radius: 15px;
          background: #46629a;
        }
      }
      .ant-table-tbody {
        font-size: 30px;
        line-height: 30px;
        color: #fff;
        > tr > td {
          border-color: #f5f5f5;
          padding-top: 29px;
          padding-bottom: 29px;
        }
        > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
          background: transparent;
        }
      }
      .ant-table-placeholder {
        background: transparent;
      }
    }
    ::v-deep .ant-pagination {
      width: 100%;
      text-align: center;
      padding-top: 33px;
      > li {
        width: 58px;
        height: 58px;
        box-sizing: border-box;
        border: 2px solid #46639a;
        font-weight: normal;
        font-size: 24px;
        line-height: 54px;
        text-align: center;
        background-color: transparent;
        margin: 0 10px;
        .ant-pagination-item-link {
          background-color: transparent;
          border: 0;
        }
        a {
          color: #46629a;
        }
        &.ant-pagination-item-active {
          background-color: #46629a;
          a {
            color: #fff;
          }
        }
        .ant-pagination-item-ellipsis {
          font-size: 12px;
          color: #46629a;
        }
      }
    }
  }
  &.visible {
    display: block;
    animation: anim-open 0.5s ease;
  }
  @keyframes anim-open {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>
